import http from '../../utils/axios'
import constDefinition from '../../utils/constDefinition'
const distributor = {
    state: {
        receiverTypeGroupList: [], // 收货方类型Group/类型--下拉数据
        canbeUpgradeReceiverTypeGroupList: [], // 可升级收货方类型Group/类型--下拉数据
        receiverTypeList: [], // 收货方类型--下拉数据
        tierTypeList: [], // 流向商业管理级别--下拉数据
        medicineGroupList: [], // 所属医药集团--下拉数据
        businessModeList: [], // 经营方式--下拉数据
        downstreamPropertyList: [], // 性质名称--下拉数据
        ddiStatusList: [], // DDI状态--下拉数据
        tierOneTypeList: [], //一级商分类--下拉数据
        partnerList: [], //合作客户--下拉数据
        teamAndDistrictList: [] //团队&大区
    },
    mutations: {
        initReceiverTypeGroupList (state, data) {
            state.receiverTypeGroupList = data
        },
        initCanbeUpgradeReceiverTypeGroupList (state, data) {
            state.canbeUpgradeReceiverTypeGroupList = data
        },
        // 收货方类型
        initReceiverTypeList (state, data) {
            state.receiverTypeList = data
        },
        // 流向商业管理级别
        initTierTypeList (state, data) {
            state.tierTypeList = data
        },
        // 所属医药集团--下拉数据
        initMedicineGroupList (state, data) {
            state.medicineGroupList = data
        },
        // 经营方式--下拉数据
        initBusinessModeList (state, data) {
            state.businessModeList = data
        },
        // 经营状态--下拉数据
        initBusinessStatusList (state, data) {
            state.businessStatusList = data
        },
        // 性质名称--下拉数据
        initDownstreamPropertyList (state, data) {
            state.downstreamPropertyList = data
        },
        // DDI状态--下拉数据
        initDdiStatusList (state, data) {
            state.ddiStatusList = data
        },
        // 一级商分类--下拉数据
        initTierOneTypeList (state, data) {
            state.tierOneTypeList = data
        },
        // 合作客户--下拉数据
        initPartnerList (state, data) {
            state.partnerList = data
        },
        initTeamAndDistrictList (state, data) {
            state.teamAndDistrictList = data
        },
    },
    actions: {
        getReceiverTypeGroup ({ commit }) {
            http.get(process.env.COREAPI_HOST + '/Receiver/QueryReceiverTypeCascader')
                .then(response => {
                    let dataAll = response.data;
                    dataAll.forEach(element => {
                        element.selectedAll = false;
                        element.indeterminate = false;
                        element.selectedChildren = [];
                    });
                    commit('initReceiverTypeGroupList', JSON.parse(JSON.stringify(dataAll)));
            });
        },
        getCanbeUpgradeReceiverTypeGroup ({ commit }) {
            http.get(process.env.COREAPI_HOST + '/Receiver/QueryCanbeUpgradeReceiverTypeCascader')
                .then(response => {
                    let dataAll = response.data;
                    dataAll.forEach(element => {
                        element.selectedAll = false;
                        element.indeterminate = false;
                        element.selectedChildren = [];
                    });
                    commit('initCanbeUpgradeReceiverTypeGroupList', JSON.parse(JSON.stringify(dataAll)));
            });
        },
        // 收货方类型--下拉
        getReceiverType ({ commit }) {
            http.get(process.env.COREAPI_HOST + '/ReceiverType/QueryCanbeUpgradeReceiverType').then(function (response) {
                commit('initReceiverTypeList', response.data)
            })
        },
        // 流向商业管理级别--下拉
        getTierType ({ commit }) {
            http.get(process.env.COREAPI_HOST + '/Dictionary/QueryDictionaryItemSelectList', {
                params: {
                    dictionaryCode: constDefinition.receiver.dictionary.TIERTYPE
                }
            }).then(function (response) {
                commit('initTierTypeList', response.data)
            })
        },
        // 所属医药集团--下拉数据
        getMedicineGroup ({ commit }) {
            http.get(process.env.COREAPI_HOST + '/Dictionary/QueryDictionaryItemSelectList', {
                params: {
                    dictionaryCode: constDefinition.receiver.dictionary.MEDICINEGROUP
                }
            }).then(function (response) {
                commit('initMedicineGroupList', response.data)
            })
        },
        // 经营方式--下拉数据
        getBusinessMode ({ commit }) {
            http.get(process.env.COREAPI_HOST + '/Dictionary/QueryDictionaryItemSelectList', {
                params: {
                    dictionaryCode: constDefinition.receiver.dictionary.BUSINESSMODE
                }
            }).then(function (response) {
                commit('initBusinessModeList', response.data)
            })
        },
        // 经营状态--下拉数据
        getBusinessStatus ({ commit }) {
            http.get(process.env.COREAPI_HOST + '/Receiver/QueryBusinessStateSelectList').then(function (response) {
                commit('initBusinessStatusList', response.data)
            })
        },
        // 性质名称--下拉数据
        getDownstreamProperty ({ commit }) {
            http.get(process.env.COREAPI_HOST + '/Dictionary/QueryDictionaryItemSelectList', {
                params: {
                    dictionaryCode: constDefinition.receiver.dictionary.DOWNSTREAMPROPERTY
                }
            }).then(function (response) {
                commit('initDownstreamPropertyList', response.data)
            })
        },
        // DDI状态--下拉数据
        getDDIStatus ({ commit }) {
            http.get(process.env.COREAPI_HOST + '/Dictionary/QueryDictionaryItemSelectList', {
                params: {
                    dictionaryCode: constDefinition.receiver.dictionary.DDISTATUS
                }
            }).then(function (response) {
                commit('initDdiStatusList', response.data)
            })
        },
        // 一级商分类--下拉数据
        getTierOneType ({ commit }) {
            http.get(process.env.COREAPI_HOST + '/Dictionary/QueryDictionaryItemSelectList', {
                params: {
                    dictionaryCode: constDefinition.receiver.dictionary.TIERONETYPE
                }
            }).then(function (response) {
                commit('initTierOneTypeList', response.data)
            })
        },
        //合作客户--下拉数据
        getPartner ({ commit }) {
            http.get(process.env.COREAPI_HOST + '/Dictionary/QueryDictionaryItemSelectList', {
                params: {
                    dictionaryCode: constDefinition.receiver.dictionary.ECPARTNER
                }
            }).then(function (response) {
                commit('initPartnerList', response.data)
            })
        },
        getTeamAndDistrict ({ commit }) {
            http.get(process.env.COREAPI_HOST + '/Location/QueryTeamAndRegionCascader', {
            }).then(function (response) {
                let dataAll = response.data;
                    dataAll.forEach(element => {
                        element.selectedAll = false;
                        element.indeterminate = false;
                        element.selectedChildren = [];
                    });
                commit('initTeamAndDistrictList', response.data)
            })
        }
    }
}
export default distributor



// WEBPACK FOOTER //
// ./src/store/modules/distributor.js